import React from 'react';
import { Search } from 'lucide-react';
import { Input } from './ui/Input';
export function Header() {
  return <header className="flex items-center justify-between px-6 py-2 border-b border-border bg-background sticky top-0 z-10" data-id="element-141">
      <div className="flex items-center gap-4" data-id="element-142">
        <div className="px-3 py-1.5" style={{
        backgroundColor: '#4400B2'
      }} data-id="element-143">
          <img src="https://cdn.magicpatterns.com/uploads/puhYcBvBrSc6k52kH6mSRG/Logo_visibility.is.png" alt="visibility.is" className="h-7" data-id="element-144" />
        </div>
        <span className="text-xs text-muted-foreground font-mono hidden sm:inline-block" data-id="element-145">
          Values-first employer research
        </span>
      </div>

      <div className="flex items-center gap-4" data-id="element-146">
        <div className="relative w-64 hidden md:block" data-id="element-147">
          <Search className="absolute left-2 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground" data-id="element-148" />
          <Input placeholder="Search companies..." className="h-7 pl-8 text-xs font-mono bg-muted/50 border-border/50 focus-visible:ring-1 focus-visible:ring-ring" data-id="element-149" />
        </div>
        <div className="text-[10px] text-muted-foreground font-mono uppercase tracking-wider" data-id="element-150">
          Last updated: Mar 2026
        </div>
      </div>
    </header>;
}